import { useState, useEffect } from "react";
import "./BlogPage.scss";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import automation1 from "../../assests/img/automation1.png";
import theData from "../../Data/Blog(Content11).json";
import { useParams } from "react-router-dom";
import { fetchBlogById } from "../../services/blogApi";
import { decodeEntityId, buildBlogPath } from "../../util/slugId";
import { getBlogImage } from "../../util/mediaHelpers";
import Seo from "../../components/Seo/Seo";

const BlogPage = () => {
  const [carousalStatus, setCarousalStatus] = useState(true);
  const [blogData, setBlogData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const handleClick = (data) => {
    setCarousalStatus(data);
  };

  const { slug } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const loadBlog = async () => {
      setIsLoading(true);

      try {
        const blogId = decodeEntityId(slug);
        const data = await fetchBlogById(blogId);
        setBlogData(data);
      } catch (error) {
        const fallback = theData.find(
          (item) =>
            item.id === slug ||
            item.id === decodeEntityId(slug) ||
            String(item.id) === String(slug),
        );
        setBlogData(fallback || null);
      } finally {
        setIsLoading(false);
      }
    };

    loadBlog();
  }, [slug]);

  if (isLoading) {
    return (
      <div className="loader-div">
        <div className="loader">
          <lottie-player
            autoplay
            loop
            src="https://lottie.host/7d0ba31f-e11f-47ed-8248-b1a8f5389ad8/oMZAHSKOuQ.json"
          ></lottie-player>
        </div>
      </div>
    );
  }

  return blogData ? (
    <div className="blog_listingPage">
      <Seo
        title={blogData.title}
        description={blogData.desc || blogData.paraOne || blogData.paraHeading}
        path={buildBlogPath(blogData.id)}
        image={getBlogImage(blogData)}
        type="article"
      />
      <div className="center-blog-section">
        <Header handleClick={handleClick} />
        <div className="blog_Inner">
          <div className="page_Head">
            <p className="smallText">{blogData?.topic}</p>
            <p className="heading">{blogData?.title}</p>
          </div>
          <p className="innerContent">{blogData?.desc}</p>
          <img src={getBlogImage(blogData)} className="w-100" alt={blogData.title} />
          <div className="center_Section">
            <div className="margin_Section">
              <p className="heading text-center">{blogData?.paraHeading}</p>
              <p className="innerText">{blogData?.paraOne}</p>
              <div className="ul_Li">
                <p className="heading_Ul">{blogData?.questionOne}</p>

                {blogData?.answereList?.map((element) => {
                  return (
                    <ul key={element.id}>
                      <li>{element.pointOne}</li>
                    </ul>
                  );
                })}
              </div>
            </div>
            <img src={automation1} className="w-100" alt={blogData.paraHeading || blogData.title} />
            <div className="content">
              <p className="heading">{blogData?.questionTwo}</p>
              <p className="innerText">{blogData?.answerPara}</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  ) : (
    <div className="loader-div">
      <h2>Data Not Found!!!</h2>
    </div>
  );
};

export default BlogPage;
